import entitiesService from "../../services/entitiesService";

const state = {
    entities: []
};

const getters = {
    entities: state => state.entities,
};

const actions = {
    getEntities({commit}) {
        entitiesService.fetchEntities()
            .then(results => {
                commit('setEntities', results)
            })
            .catch(error => {
                console.log(error)
            })
    },
};

const mutations = {
    setEntities(state, results) {
        state.entities = results['results']
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}